<div class="split left">
  <header>
    <div class="main-header d-flex justify-content-between align-items-center">
      <div class="logo default-pointer" (click)="navigate()">
        <img src="../../assets/automapai-logo.png" class="header-termhub-logo" alt="AutomapAI" />
      </div>
    </div>
  </header>

  <div class="signup-body">
    <div>
      <span class="header-text">Log In</span>
    </div>
    <div class="title mt-3" [hidden]="!verified">
      <div class="green-title verified-message">
        <img src="../../assets/check-circle.png" class="body-circled-check" alt="Check" /> Your email has been verified!
      </div>
    </div>
    <div class="login-box">
      <div class="login-form mt-3">
        <p class="not-found mt-1" *ngIf="noAccount">Unable to find an account associated with this email and password.</p>
        <div class="mb-3" *ngIf="emailVerified === false && emailExist">
          <span class="is-invalid">This user is not verified.</span>
          <span> Would you like to <a class="form-link" [routerLink]="''" (click)="resendVerificationEmail()">Resend verification email</a>? </span>
        </div>
        <div class="mb-3" [hidden]="valid">
          This email is not yet verified. Would you like to
          <a href (click)="!!resendVerificationEmail()" class="form-link">resend the verification email?</a>
        </div>
        <div>
          <app-input
            [for]="'usernameInputFC'"
            label="Email"
            placeholder="Enter your email"
            type="email"
            [control]="emailFC"
            [required]="true"
            (keydown.enter)="onSubmit()"
          ></app-input>
          <div class="form-group" [hidden]="!valid">
            <div class="input-container h-fit-content">
              <div class="view-password">
                <app-input
                  [for]="'passwordInputFC'"
                  *ngIf="!show_eye"
                  label="Password"
                  placeholder="Enter your password"
                  type="password"
                  [control]="passwordFC"
                  [required]="true"
                  (keydown.enter)="onSubmit()"
                ></app-input>
                <app-input
                  [for]="'passwordInputFC'"
                  *ngIf="show_eye"
                  label="Password"
                  placeholder="Enter your password"
                  type="text"
                  [control]="passwordFC"
                  [required]="true"
                  (keydown.enter)="onSubmit()"
                ></app-input>
                <div *ngIf="show_eye" class="show-hide-eye default-pointer" (click)="showPassword(false)">
                  <i class="fa-solid fa-eye svg-inline-auth m-t-3"> </i>
                </div>
                <div *ngIf="!show_eye" class="show-hide-eye default-pointer" (click)="showPassword(true)">
                  <i class="fa-solid fa-eye-slash svg-inline-auth m-t-3"> </i>
                </div>
              </div>
            </div>

            <div class="is-unauthorized" [hidden]="!unauthorized">Username or password is incorrect. Please try again.</div>
            <div class="password-maintenance d-none">
              <a id="forgotPasswordLink1" class="form-link" [routerLink]="'/password-reset'">Forgot your password?</a>
            </div>
          </div>
          <div class="form-group">
            <app-button for="loginButton" btnType="login" type="submit" [hidden]="!valid" (click)="onSubmit()">Log In</app-button>
            <app-button for="resendButton" btnType="login" type="submit" [hidden]="!valid" [hidden]="valid" (click)="resendVerificationEmail()"
              >Resend email</app-button
            >
          </div>
        </div>
      </div>

      <div>
        To request a demo account, contact
        <a class="form-link" href="mailto:info@terminologyhub.com?subject=AutomapAI%20Demo%20Account%20Request">{{ contactEmail }}</a> or
        <a class="form-link" [routerLink]="'/signup'"> sign up</a>
      </div>
      <div class="new-account mt-3">
        <div class="signup-link">
          <a id="forgotPasswordLink2" [hidden]="!(emailExist === true && emailVerified === true)" class="form-link" [routerLink]="'/password-reset'"
            >Forgot your password?</a
          >
        </div>
      </div>
    </div>
  </div>
</div>
<div class="split right tinted-image"></div>
